import {
  ADD_FAVOURITE_FEATURE,
  ADD_FAVOURITE_FEATURE_SUCCESS,
  FETCH_FEATURE,
  FETCH_FEATURE_SUCCESS,
  FETCH_ALL_FEATURE,
  FETCH_ALL_FEATURE_SUCCESS,
  FILTER_FEATURE,
  GET_ALL_FEATURE,
  GET_UNSELECTED_ALL_FEATURE,
  HANDLE_FEATURE_REQUEST_CLOSE,
  HIDE_FEATURE_LOADER,
  SHOW_FEATURE_LOADER,
  ON_ADD_FEATURE,
  ON_ALL_FEATURE_SELECT,
  ON_FEATURE_CLOSE,
  ON_FEATURE_SELECT,
  ON_DELETE_FEATURE,
  ON_DELETE_FEATURE_SUCCESS,
  ON_FILTER_SELECTED_FEATURE,
  ON_FILTER_FEATURE_OPTION_SELECT,
  ON_SAVE_FEATURE,
  ON_SAVE_FEATURE_SUCCESS,
  ON_TOGGLE_FEATURE_DRAWER,
  SHOW_FEATURE_MESSAGE,
  UPDATE_SEARCH_FEATURE,
  SET_FEATURE,
  ON_EDIT_FEATURE,
  ON_FEATURE_INWARD_DEPENDENCY_UPDATE,
  ON_FEATURE_OUTWARD_DEPENDENCY_UPDATE,
  ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS,
  ON_FETCH_SELECT_FEATURE_INWARD_DEPENDENCIES,
  ON_FETCH_SELECT_FEATURE_OUTWARD_DEPENDENCIES,
  ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS,
} from 'constants/ActionTypes';

export const onFetchSelectFeatureInwardDependencies = () => {
  return {
      type: ON_FETCH_SELECT_FEATURE_INWARD_DEPENDENCIES,
  };
};
export const onFetchSelectFeatureOutwardDependencies = () => {
  return {
      type: ON_FETCH_SELECT_FEATURE_OUTWARD_DEPENDENCIES,
  };
};
export const onFetchSelectFeatureDependenciesSuccess = (payload) => {
  return {
      type: ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS,
      payload
  };
};
export const onFeatureInwardDependencyUpdate = (payload) => {
  return {
      type: ON_FEATURE_INWARD_DEPENDENCY_UPDATE,
      payload
  };
};
export const onFeatureOutwardDependencyUpdate = (payload) => {
  return {
      type: ON_FEATURE_OUTWARD_DEPENDENCY_UPDATE,
      payload
  };
};
export const onFeatureDependencyUpdateSuccess = (payload) => {
  return {
      type: ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS,
      payload
  };
};
export const fetchFeature = (payload) => {
  return {
      type: FETCH_FEATURE,
      payload
  };
};
export const fetchFeatureSuccess = (payload) => {
  return {
      type: FETCH_FEATURE_SUCCESS,
      payload
  };
};
export const setFeature = (payload) => {
  return {
      type: SET_FEATURE,
      payload
  };
};
export const fetchFeatures = () => {
  return {
      type: FETCH_ALL_FEATURE
  };
};
export const fetchFeaturesSuccess = (payload) => {
  return {
      type: FETCH_ALL_FEATURE_SUCCESS,
      payload
  };
};
export const showFeatureMessage = (message) => {
  return {
      type: SHOW_FEATURE_MESSAGE,
      payload: message
  };
};
export const addFavouriteFeature = (payload) => {
  return {
      type: ADD_FAVOURITE_FEATURE,
      payload
  };
};
export const addFavouriteFeatureSuccess = (payload) => {
  return {
      type: ADD_FAVOURITE_FEATURE_SUCCESS,
      payload
  };
};
export const onFeatureSelect = (payload) => {
  return {
      type: ON_FEATURE_SELECT,
      payload
  };
};
export const onAddFeature = () => {
  return {
      type: ON_ADD_FEATURE,
      payload: ''
  };
};
export const onEditFeature = () => {
  return {
      type: ON_EDIT_FEATURE,
      payload: ''
  };
};
export const onFeatureClose = () => {
  return {
      type: ON_FEATURE_CLOSE,
      payload: ''
  };
};
export const onFilterFeatureOptionSelect = (payload) => {
  return {
      type: ON_FILTER_FEATURE_OPTION_SELECT,
      payload
  };
};
export const onSaveFeature = (payload) => {
  return {
      type: ON_SAVE_FEATURE,
      payload
  };
};
export const onSaveFeatureSuccess = (data) => {
  return {
      type: ON_SAVE_FEATURE_SUCCESS,
      payload: data
  };
};
export const onDeleteFeature = (payload) => {
  return {
      type: ON_DELETE_FEATURE,
      payload
  };
};
export const onDeleteFeatureSuccess = (payload) => {
  return {
      type: ON_DELETE_FEATURE_SUCCESS,
      payload
  };
};
export const onFilterSelectedFeature = () => {
  return {
      type: ON_FILTER_SELECTED_FEATURE,
      payload: ''
  };
};
export const filterFeature = (payload) => {
  return {
      type: FILTER_FEATURE,
      payload
  };
};
export const getAllFeature = () => {
  return {
      type: GET_ALL_FEATURE,
      payload: ''
  };
};
export const getUnselectedAllFeature = () => {
  return {
      type: GET_UNSELECTED_ALL_FEATURE,
      payload: ''
  };
};
export const onAllFeatureSelect = () => {
  return {
      type: ON_ALL_FEATURE_SELECT,
      payload: ''
  };
};
export const updateSearchFeature = (payload) => {
  return {
      type: UPDATE_SEARCH_FEATURE,
      payload
  };
};
export const onToggleFeatureDrawer = () => {
  return {
      type: ON_TOGGLE_FEATURE_DRAWER,
  };
};
export const handleFeatureRequestClose = () => {
  return {
      type: HANDLE_FEATURE_REQUEST_CLOSE,
  };
};
export const showFeatureLoader = () => {
  return {
      type: SHOW_FEATURE_LOADER,
  };
};
export const hideFeatureLoader = () => {
  return {
      type: HIDE_FEATURE_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/feature.js